<template>
  <div
    class="list-card"
    :class="{white:white,noPadding:noPadding,outline:outline,borderTop:borderTop,'border-bottom':hasBorderBottom}"
  >
    <div
      class="list-card__title-wrap"
    >
      <LvText
        v-if="title"
        bold
        :h3="bigTitle"
        class="list-card__title"
      >
        {{ $t(title) }}
      </LvText>
      <slot name="titleChips"/>
    </div>
    <component
      :is="isTable?'table':'div'"
      class="list-card_content"
      :style="{'border-spacing': borderSpacing}"
    >
      <slot />
      <div
        v-for="(listItem,listItemIndex) in cardList"
        :key="listItemIndex"
        class="list-card_content-item"
      >
        <div
          v-if="listItem.type==='multiple'"
          class="list-card_content-item-multiple"
        >
          <ListCardItem
            v-for="(item,itemIndex) in listItem.list"
            :key="itemIndex"
            :is-table="isTable"
            :row="isRow"
            :type="item.type"
            :title="item.title"
            :time="item.time"
            :avatar-image="item.avatarImage"
            :avatar-name="item.name"
            :leading-icon="item.leadingIcon"
            :text-content="item.text"
            :valid-start="item.validStart"
            :valid-end="item.validEnd"
            :avatars="item.avatars"
            :chips="item.chips"
            :condition="item.condition"
            :overdue="item.overdue"
            :clickable="item.clickable"
            :button-text="item.buttonText"
            :attaches="item.attaches"
            :to="item.to"
          />
        </div>
        <ListCardItem
          v-else
          :is-table="isTable"
          :row="isRow"
          :type="listItem.type"
          :title="listItem.title"
          :time="listItem.time"
          :avatar-image="listItem.avatarImage"
          :avatar-name="listItem.name"
          :leading-icon="listItem.leadingIcon"
          :text-content="listItem.text"
          :valid-start="listItem.validStart"
          :valid-end="listItem.validEnd"
          :avatars="listItem.avatars"
          :chips="listItem.chips"
          :condition="listItem.condition"
          :overdue="listItem.overdue"
          :clickable="listItem.clickable"
          :button-text="listItem.buttonText"
          :attaches="listItem.attaches"
          :to="listItem.to"
        />
      </div>
    </component>
  </div>
</template>
<script>
export default {
  name: "ListCard",
  props: {
    isTable: {
      type: Boolean,
      default: false,
    },
    white: {
      type: Boolean,
      default: false,
    },
    noPadding: {
      type: Boolean,
      default: false,
    },
    outline: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    borderTop: {
      type: Boolean,
      default: false,
    },
    bigTitle: {
      type: Boolean,
      default: false,
    },
    cardList: {
      type: Array,
      default() {
        return [];
      },
    },
    isRow: {
      type: Boolean,
      default: false,
    },
    hasBorderBottom: {
      type: Boolean,
      default: false,
    },
    borderSpacing: {
      type: String,
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/component/list-card";
</style>